module.exports = __webpack_public_path__ + "media/madden_sizzle_reel_video.dc4796b1.mp4";